import { createSlice } from "@reduxjs/toolkit";

const qualityFrameworkSlice = createSlice({
  name: "qualityFramework",
  initialState: {
    refreshId: 0,
  },
  reducers: {
    triggerQualityFrameworkRefresh: (state) => {
      state.refreshId += 1;
    },
  },
});

export const { triggerQualityFrameworkRefresh } = qualityFrameworkSlice.actions;

export default qualityFrameworkSlice.reducer;